module.exports = __webpack_public_path__ + "static/pnevmo-869b81b4b38c2b87658a5f0e187c21bd.webp";